import { EntityType, RateInterval } from '__types__';
import { UseFormReturn } from 'react-hook-form';
import { RateInput } from 'v1/components/shared';

type RateInputFieldProps = {
  form: UseFormReturn<any>;
  currencyName: string;
  amountName: string;
  intervalName: string;
  entityType?: EntityType.BOOKING | EntityType.EXPENSE;
  defaultCurrency?: Currency;
  placeholder?: string;
  disabled?: boolean;
};

export function RateInputField({
  form,
  currencyName,
  amountName,
  intervalName,
  entityType,
  defaultCurrency,
  placeholder,
  disabled
}: RateInputFieldProps) {
  const currency = form.watch(currencyName);
  const amount = form.watch(amountName);
  const interval = form.watch(intervalName);

  const handleChange = (value: {
    currency: Currency;
    amount: CurrencyAmount | null;
    interval: RateInterval;
  }) => {
    form.setValue(currencyName, value.currency, {
      shouldDirty: true,
      shouldValidate: false
    });
    form.setValue(amountName, value.amount, {
      shouldDirty: true,
      shouldValidate: false
    });
    form.setValue(intervalName, value.interval, {
      shouldDirty: true,
      shouldValidate: false
    });
  };

  return (
    // @ts-expect-error
    <RateInput
      placeholder={placeholder}
      defaultCurrency={defaultCurrency}
      entityType={entityType}
      disabled={disabled}
      value={{
        currency,
        amount,
        interval
      }}
      onChange={handleChange}
    />
  );
}
